/**
 * Service for creating SD Retargeting / Remarketing campaigns
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const SdRetargetingCampaignAPI = {
    /**
     * Sube archivos CSV y logo
     */
    uploadFiles: async function (ownProductsCSV, retargetingCSV, logo) {
        const formData = new FormData();

        if (ownProductsCSV) formData.append('ownProductsCSV', ownProductsCSV);
        if (retargetingCSV) formData.append('retargetingCSV', retargetingCSV);
        if (logo) formData.append('logo', logo);

        const response = await fetch(`${API_BASE_URL}/sd-retargeting-campaigns/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Error uploading files');
        }

        return await response.json();
    },

    /**
     * Crea la campaña SD Retargeting completa
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('headline', options.headline || '');
        formData.append('ownProducts', JSON.stringify(options.ownProducts || []));
        formData.append('retargetingAsins', JSON.stringify(options.retargetingAsins || []));
        formData.append('lookbackWindow', options.lookbackWindow || 30);
        formData.append('retargetingType', options.retargetingType || 'asinViews');

        if (options.startDate) formData.append('startDate', options.startDate);
        if (options.endDate) formData.append('endDate', options.endDate);
        if (options.bidOptimization) formData.append('bidOptimization', options.bidOptimization);
        if (options.defaultBid) formData.append('defaultBid', options.defaultBid);
        if (options.state) formData.append('state', options.state);
        if (options.logo) formData.append('logo', options.logo);

        const response = await fetch(`${API_BASE_URL}/sd-retargeting-campaigns/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Error creating retargeting campaign');
        }

        return await response.json();
    }
};

export default SdRetargetingCampaignAPI;
